import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import PublicHeader from "@/components/PublicHeader";
import SiteFooter from "@/components/SiteFooter";
import CompanyCard from "@/components/CompanyCard";
import { api, salaryText } from "@/lib/api";
import { useSeo } from "@/lib/seo";
import { ct } from "@/lib/time";

export default function CompanyPage() {
  const { companyId } = useParams();
  const [c, setC] = useState(null);
  useEffect(() => { api.get(`/public/company/${companyId}`).then((r) => setC(r.data)).catch(() => setC(false)); }, [companyId]);
  useSeo({ title: c ? `Jobs at ${c.org_name}` : "Company", path: `/company/${companyId}`, description: c ? (c.about || "").slice(0, 155) : "Company profile on JobPedestal" });
  return (
    <div className="min-h-screen" data-testid="company-page">
      <PublicHeader />
      <main className="mx-auto max-w-4xl px-4 py-12 sm:px-8">
        {c === false && <p className="text-slate-600" data-testid="company-not-found">This company profile isn't available.</p>}
        {c && <>
          <h1 className="mb-6 text-3xl font-extrabold sm:text-4xl">{c.org_name}</h1>
          <CompanyCard c={c} link={false} />
          <h2 className="mt-10 text-xl font-bold">Open roles ({c.jobs.length})</h2>
          <div className="mt-4 space-y-3">{c.jobs.map((j) => (
            <Link key={j.job_id} to={`/job/${j.job_id}`} className="lift block rounded-2xl border bg-white p-4" data-testid={`company-job-${j.job_id}`}>
              <p className="font-semibold">{j.title}</p><p className="text-sm text-slate-600">{j.location} · {j.location_type} · <span className="text-emerald-700">{salaryText(j)}</span></p>
              <p className="text-xs text-slate-500">Posted {ct(j.posted_at)}</p></Link>))}
            {c.jobs.length === 0 && <p className="text-sm text-slate-500">No open roles right now.</p>}</div>
        </>}
      </main>
      <SiteFooter />
    </div>
  );
}
